<app-login (loggedIn)="loggedIn($event)" *ngIf="!isLoggedIn" [class.hidden]="loading"></app-login>
